import { useTranslation } from 'react-i18next'
import React from 'react'
import styled from 'styled-components'
import { ReactComponent as Info } from '@dataplace.ai/assets/lib/icons/largeIcons/info.svg'
import { useGetAttractivenessDropdownOptions } from './useGetAttractivenessDropdownOptions'
import { COMPONENT_TYPES } from '../../Potential/Attractiveness/constants'
import { AlabAttractivenessFormDataObject, AlabAttractivenessFormFields, AlabAttractivenessFormState, FormElement } from '../@types/IAlabAttractivenessTileData'

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1rem;
`
const DescriptionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 0.15rem;
`

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.2rem;
  align-items: start;

  > svg {
    path {
      stroke: #234596;
    }
  }
`

export const useAlabAttractivenessFormData = (
  formState: AlabAttractivenessFormState,
): AlabAttractivenessFormDataObject => {
  const { t } = useTranslation()

  const { marketTypeOptions } = useGetAttractivenessDropdownOptions()

  const iconWH = 24

  const formElementData: FormElement[] = [
    {
      sectionTitle: t('placeme.attractiveness.section.market_type.title'),
      sectionDescription: (
        <DescriptionWrapper>
          <span>{t('placeme.attractiveness.section.market_type.description_1')}</span>
          <InfoRow>
            <Info
              height={iconWH}
              width={iconWH}
            />
            <DescriptionRow>
              <span>{t('placeme.attractiveness.section.market_type.description_2')}</span>
              <span>{t('placeme.attractiveness.section.market_type.description_3')}</span>
            </DescriptionRow>
          </InfoRow>
        </DescriptionWrapper>
      ),
      formStateElement: formState.market,
      inputKey: AlabAttractivenessFormFields.market,
      options: marketTypeOptions,
      title: t('placeme.attractiveness.section.market_type.title'),
      componentType: COMPONENT_TYPES.DROPDOWN,
    },
  ]

  return {
    formElementData,
  }
}
